"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

var _combineStreams = _interopRequireDefault(require("../util/combine-streams"));

var _constants = require("../util/constants");

var _devices = _interopRequireDefault(require("./devices"));

var _apiKeys = _interopRequireDefault(require("./api-keys"));

var _link = _interopRequireDefault(require("./link"));

var _collaborators = _interopRequireDefault(require("./collaborators"));

var _webhooks = _interopRequireDefault(require("./webhooks"));

var _pubsubs = _interopRequireDefault(require("./pubsubs"));

var _applicationPackages = _interopRequireDefault(require("./application-packages"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var IS = _constants.STACK_COMPONENTS_MAP.is,
    AS = _constants.STACK_COMPONENTS_MAP.as,
    NS = _constants.STACK_COMPONENTS_MAP.ns,
    JS = _constants.STACK_COMPONENTS_MAP.js,
    DTC = _constants.STACK_COMPONENTS_MAP.dtc;
/**
 * Applications Class provides an abstraction on all applications and manages
 * data handling from different sources. It exposes an API to easily work with
 * application data.
 *
 * @param {object} api - The connector to be used by the service.
 * @param {object} config - The configuration for the service.
 * @param {string} config.defaultUserId - The users identifier to be used in
 * user related requests.
 * @param {boolean} config.proxy - The flag to identify if the results
 * should be proxied with the wrapper objects.
 */

var Applications = /*#__PURE__*/function () {
  function Applications(api, _ref) {
    var defaultUserId = _ref.defaultUserId,
        stackConfig = _ref.stackConfig;
    (0, _classCallCheck2["default"])(this, Applications);
    this._defaultUserId = defaultUserId;
    this._api = api;
    this._stackConfig = stackConfig;
    this.ApiKeys = new _apiKeys["default"](api.ApplicationAccess, {
      parentRoutes: {
        get: 'application_ids.application_id',
        list: 'application_ids.application_id',
        create: 'application_ids.application_id',
        update: 'application_ids.application_id'
      }
    });
    this.Link = new _link["default"](api.As);
    this.Devices = new _devices["default"](api, {
      stackConfig: stackConfig
    });
    this.Collaborators = new _collaborators["default"](api.ApplicationAccess, {
      parentRoutes: {
        get: 'application_ids.application_id',
        list: 'application_ids.application_id',
        set: 'application_ids.application_id'
      }
    });
    this.Webhooks = new _webhooks["default"](api.ApplicationWebhookRegistry);
    this.PubSubs = new _pubsubs["default"](api.ApplicationPubSubRegistry);
    this.Packages = new _applicationPackages["default"](api.ApplicationPackageRegistry);
    (0, _autoBind["default"])(this);
  } // Retrieval.


  (0, _createClass2["default"])(Applications, [{
    key: "getAll",
    value: function () {
      var _getAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(params, selector) {
        var response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.ApplicationRegistry.List(undefined, _objectSpread(_objectSpread({}, params), _marshaler["default"].selectorToFieldMask(selector)));

              case 2:
                response = _context.sent;
                return _context.abrupt("return", _marshaler["default"].unwrapApplications(response));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAll(_x, _x2) {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "getById",
    value: function () {
      var _getById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(id, selector) {
        var fieldMask, response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context2.next = 3;
                return this._api.ApplicationRegistry.Get({
                  routeParams: {
                    'application_ids.application_id': id
                  }
                }, fieldMask);

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].unwrapApplication(response));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getById(_x3, _x4) {
        return _getById.apply(this, arguments);
      }

      return getById;
    }()
  }, {
    key: "getByOrganization",
    value: function () {
      var _getByOrganization = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(organizationId) {
        var response;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                response = this._api.ApplicationRegistry.List({
                  routeParams: {
                    'collaborator.organization_ids.organization_id': organizationId
                  }
                });
                return _context3.abrupt("return", _marshaler["default"].unwrapApplications(response));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getByOrganization(_x5) {
        return _getByOrganization.apply(this, arguments);
      }

      return getByOrganization;
    }()
  }, {
    key: "getByCollaborator",
    value: function () {
      var _getByCollaborator = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(userId) {
        var response;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                response = this._api.ApplicationRegistry.List({
                  routeParams: {
                    'collaborator.user_ids.user_id': userId
                  }
                });
                return _context4.abrupt("return", _marshaler["default"].unwrapApplications(response));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getByCollaborator(_x6) {
        return _getByCollaborator.apply(this, arguments);
      }

      return getByCollaborator;
    }()
  }, {
    key: "search",
    value: function () {
      var _search = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(params, selector) {
        var response;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._api.EntityRegistrySearch.SearchApplications(undefined, _objectSpread(_objectSpread({}, params), _marshaler["default"].selectorToFieldMask(selector)));

              case 2:
                response = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].unwrapApplications(response));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function search(_x7, _x8) {
        return _search.apply(this, arguments);
      }

      return search;
    }() // Update.

  }, {
    key: "updateById",
    value: function () {
      var _updateById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(id, patch) {
        var mask,
            response,
            _args6 = arguments;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                mask = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : _marshaler["default"].fieldMaskFromPatch(patch, this._api.ApplicationRegistry.UpdateAllowedFieldMaskPaths);
                _context6.next = 3;
                return this._api.ApplicationRegistry.Update({
                  routeParams: {
                    'application.ids.application_id': id
                  }
                }, {
                  application: patch,
                  field_mask: _marshaler["default"].fieldMask(mask)
                });

              case 3:
                response = _context6.sent;
                return _context6.abrupt("return", _marshaler["default"].unwrapApplication(response));

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function updateById(_x9, _x10) {
        return _updateById.apply(this, arguments);
      }

      return updateById;
    }()
  }, {
    key: "restoreById",
    value: function () {
      var _restoreById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(id) {
        var response;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._api.ApplicationRegistry.Restore({
                  routeParams: {
                    application_id: id
                  }
                });

              case 2:
                response = _context7.sent;
                return _context7.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function restoreById(_x11) {
        return _restoreById.apply(this, arguments);
      }

      return restoreById;
    }() // Creation.

  }, {
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
        var ownerId,
            application,
            isUserOwner,
            routeParams,
            response,
            _args8 = arguments;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                ownerId = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : this._defaultUserId;
                application = _args8.length > 1 ? _args8[1] : undefined;
                isUserOwner = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : true;
                routeParams = isUserOwner ? {
                  'collaborator.user_ids.user_id': ownerId
                } : {
                  'collaborator.organization_ids.organization_id': ownerId
                };
                _context8.next = 6;
                return this._api.ApplicationRegistry.Create({
                  routeParams: routeParams
                }, {
                  application: application
                });

              case 6:
                response = _context8.sent;
                return _context8.abrupt("return", _marshaler["default"].unwrapApplication(response));

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function create() {
        return _create.apply(this, arguments);
      }

      return create;
    }() // Deletion.

  }, {
    key: "deleteById",
    value: function () {
      var _deleteById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(applicationId) {
        var response;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this._api.ApplicationRegistry.Delete({
                  routeParams: {
                    application_id: applicationId
                  }
                });

              case 2:
                response = _context9.sent;
                return _context9.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function deleteById(_x12) {
        return _deleteById.apply(this, arguments);
      }

      return deleteById;
    }()
  }, {
    key: "purgeById",
    value: function () {
      var _purgeById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(id) {
        var response;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this._api.ApplicationRegistry.Purge({
                  routeParams: {
                    application_id: id
                  }
                });

              case 2:
                response = _context10.sent;
                return _context10.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function purgeById(_x13) {
        return _purgeById.apply(this, arguments);
      }

      return purgeById;
    }() // DevEUI issuing.

  }, {
    key: "issueDevEUI",
    value: function () {
      var _issueDevEUI = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(id) {
        var response;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this._api.ApplicationRegistry.IssueDevEUI({
                  routeParams: {
                    application_id: id
                  }
                });

              case 2:
                response = _context11.sent;
                return _context11.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function issueDevEUI(_x14) {
        return _issueDevEUI.apply(this, arguments);
      }

      return issueDevEUI;
    }() // Miscellaneous.

  }, {
    key: "getRightsById",
    value: function () {
      var _getRightsById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(applicationId) {
        var result;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this._api.ApplicationAccess.ListRights({
                  routeParams: {
                    application_id: applicationId
                  }
                });

              case 2:
                result = _context12.sent;
                return _context12.abrupt("return", _marshaler["default"].unwrapRights(result));

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getRightsById(_x15) {
        return _getRightsById.apply(this, arguments);
      }

      return getRightsById;
    }()
  }, {
    key: "getMqttConnectionInfo",
    value: function () {
      var _getMqttConnectionInfo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(applicationId) {
        var response;
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this._api.AppAs.GetMQTTConnectionInfo({
                  routeParams: {
                    application_id: applicationId
                  }
                });

              case 2:
                response = _context13.sent;
                return _context13.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getMqttConnectionInfo(_x16) {
        return _getMqttConnectionInfo.apply(this, arguments);
      }

      return getMqttConnectionInfo;
    }() // Events Stream

  }, {
    key: "openStream",
    value: function () {
      var _openStream = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(identifiers, names, tail, after) {
        var _this = this;

        var payload, distinctComponents, streams;
        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                payload = {
                  identifiers: identifiers.map(function (id) {
                    return {
                      application_ids: {
                        application_id: id
                      }
                    };
                  }),
                  names: names,
                  tail: tail,
                  after: after
                }; // Event streams can come from multiple stack components. It is necessary to
                // check for stack components on different hosts and open distinct stream
                // connections for any distinct host if need be.

                distinctComponents = this._stackConfig.getComponentsWithDistinctBaseUrls([IS, JS, NS, AS, DTC]);
                streams = distinctComponents.map(function (component) {
                  return _this._api.Events.Stream({
                    component: component
                  }, payload);
                }); // Combine all stream sources to one subscription generator.

                return _context14.abrupt("return", (0, _combineStreams["default"])(streams));

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function openStream(_x17, _x18, _x19, _x20) {
        return _openStream.apply(this, arguments);
      }

      return openStream;
    }()
  }]);
  return Applications;
}();

var _default = Applications;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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